<!-- DESC：负责删除论文文件 -->
<template>
    <div class="authoremail-box">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">Delete Submissions</div>
                    <br />
                    <div class="info">
                        Mark the submission(s) you want to delete and press the "Delete" button.
                    </div>
                    <div class="info">You will be asked for a confirmation. You will also be able to edit the text of a
                        message sent to the authors upon deletion.</div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="primary" :icon="ArrowLeftBold" circle plain></el-button>
            </el-col>
        </el-row>
        <!-- 邮件内容构建 -->
        <el-row>
            <el-col :span="15">
                <div class="email-box">
                    <!-- 标题 -->
                    <div style="margin-bottom:30px;border-left: 3px solid rgba(48, 132, 158, 0.575);padding-left: 10px;">
                        Email</div>
                    <el-card shadow="always">
                        <el-form :model="emailform" label-width="91px">
                            <el-form-item label="Subject:" required>
                                <el-input v-model="emailform.subject" />
                            </el-form-item>
                            <el-form-item label="Message:" required>
                                <el-input v-model="emailform.message" type="textarea" :rows="8"
                                    :autosize="{ minRows: 8, maxRows: 20 }" resize="none" />
                            </el-form-item>
                            <el-upload ref="uploadRef" class="upload-demo" :auto-upload="false" :limit="1"
                                :on-exceed="handleExceed" :http-request="sendemail" v-model:file-list="fileList">
                                <template #trigger>
                                    <el-text class="mx-1" style="margin-right: 10px;">Attachment:</el-text><el-button>select
                                        file</el-button>
                                </template>
                            </el-upload>
                            <el-form-item>
                                <el-checkbox v-model="emailform.isAllCorresponding"
                                    label="Send to all authors of selected papers (not only corresponding ones)"
                                    name="type" />
                            </el-form-item>
                        </el-form>
                        <el-divider border-style="dashed" />
                        <div style="display: flex;justify-content: center;">
                            <el-button type="primary" @click="presend">Send Email</el-button>
                            <el-button type="danger" @click="deletepaper">Delete Paper</el-button>
                        </div>
                    </el-card>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <!-- 标题 -->
                <div style="margin:30px 0;border-left: 3px solid rgba(48, 132, 158, 0.575);padding-left: 10px;">Submissions
                </div>
                <!-- 列表 -->
                <div class="paperlist-box">
                    <el-card shadow="always">
                        <div style="display: flex;justify-content: left;margin-bottom: 10px;"><el-button type="primary"
                                @click="deleted" size="small">Deleted submissions</el-button></div>
                        <el-table :data="conferencePaperList" style="width: 100%" border class="tb-box"
                            ref="multipleTableRef" @selection-change="handleSelectionChange" v-loading="loading"
                            element-loading-text="loading..." :element-loading-spinner="svg"
                            element-loading-svg-view-box="-10, -10, 50, 50" @sort-change="sortTable">
                            <el-table-column type="selection" width="55" align="center" />
                            <el-table-column label="Submission" header-align="center">
                                <template #default="scope">
                                    <el-text type="primary" class="title-text" size="small">{{ scope.row.autoid
                                    }}.{{ scope.row.authors }}/{{ scope.row.title }}</el-text>
                                </template>
                            </el-table-column>
                            <el-table-column label="Decision" align="center" header-align="center" width="100"
                                :filters="[{ text: 'ACCEPT', value: 'ACCEPT' }, { text: 'REJECT', value: 'REJECT' }, { text: 'UNKNOW', value: 'UNKNOW' }]"
                                :filter-method="filterTag">
                                <template #default="scope">
                                    <el-tag type="danger" class="title-text"
                                        v-if="scope.row.isTermination == 1">REJECT</el-tag>
                                    <el-tag type="success" class="title-text"
                                        v-else-if="scope.row.status == 4 && scope.row.isTermination != 1">ACCEPT</el-tag>
                                    <span class="title-text" v-else></span>
                                </template>
                            </el-table-column>
                            <el-table-column label="UpdateTime" align="center" width="160" sortable="custom"
                                header-align="center">
                                <template #default="scope">
                                    <el-text class="title-text" size="small">{{ scope.row.updatetime }}</el-text>
                                </template>
                            </el-table-column>
                            <el-table-column label="operate" width="240" align="center">
                                <template #header>
                                    <el-input v-model="searchValue" size="small" placeholder="enter search content"
                                        @input="changeSearchValue" :suffix-icon="Search" />
                                </template>
                                <template #default="scope">
                                    <el-button size="small" @click="look(scope.$index, scope.row)" type="danger"
                                        :icon="View">information</el-button>
                                    <el-button size="small" @click="download(scope.$index, scope.row)" type="warning"
                                        :icon="Document" style="width: 90px;">paper file</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </div>
            </el-col>
        </el-row>
        <!-- 隐藏层，已被删除的论文 -->
        <el-dialog v-model="dialogTableVisible" title="Deleted submissions" center>
            <el-table :data="conferencePaperDelList" style="width: 100%" border class="tb-box" ref="multipleTableRef"
                @selection-change="handleSelectionChange" element-loading-text="loading..." :element-loading-spinner="svg"
                element-loading-svg-view-box="-10, -10, 50, 50" @sort-change="sortTable">
                <el-table-column type="selection" width="55" align="center" />
                <el-table-column label="Submission" header-align="center">
                    <template #default="scope">
                        <el-text type="primary" class="title-text" size="small">{{ scope.row.autoid
                        }}.{{ scope.row.authors }}/{{ scope.row.title }}</el-text>
                    </template>
                </el-table-column>
                <el-table-column label="operate" width="180" align="center">
                    <template #default="scope">
                        <el-button size="small" @click="download(scope.$index, scope.row)" type="danger" :icon="Document"
                            style="width: 90px;">paper</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="recover" type="primary" size="small">Undelete</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import request from "../../network/request"
import { useRouter, useRoute } from "vue-router"
import { View, Document, Refresh, Position, Search, Plus, Message,ArrowLeftBold } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { fa } from "element-plus/es/locale"
import { useStore } from "vuex"

const route = useRoute()
const store = useStore()
const loading = ref(true)
const dialogTableVisible = ref(false)

// 排序规则
const sortRule = ref("autoid asc")
// 文件列表
const fileList = ref([])
// 邮件表单信息
const emailform = ref({ subject: `${route.query.acronym} submission deleted`, message: `Dear authors,

We had to delete your submission to ${route.query.acronym}
since we did not receive your paper by the
deadline.

Thank you for considering ${route.query.acronym}.

Best regards,
${store.state.user.firstname} ${store.state.user.lastname}.`, isAllCorresponding: false })
const emailList = ref([])
const deleteList = ref([])
// 上传文件对象
const uploadRef = ref()
// 搜索值
const searchValue = ref("")
// 上传文件覆盖
const handleExceed = (files) => {
    uploadRef.value.clearFiles()
    const file = files[0]
    file.uid = 0
    uploadRef.value.handleStart(file)
}
// 会议投稿论文
const conferencePaperList = ref([])
const conferencePaperDelList = ref([])
// 选中的论文
const multipleTableRef = ref()
const multipleSelection = ref([])
const svg = `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>`


// 表格选择列表修改
const handleSelectionChange = (val) => {
    multipleSelection.value = val
}

// 获取会议投稿论文列表
function getConferencePaperList() {
    request.get(`/conference/paperlist?pagenum=1&pagesize=99999&cid=${route.query.cid}&sortRule=${sortRule.value}&keyword=${searchValue.value}`).then((res) => {
        conferencePaperList.value = []
        let datalist = res.data.list;
        datalist.forEach((item) => {
            let authornamelist = []
            item.authorList.forEach((author) => {
                authornamelist.push(author.firstname + " " + author.lastname)
            })
            let authornames = authornamelist.join(",")
            let title = item.title
            conferencePaperList.value.push({ id: item.id, pid: item.pid, authors: authornames, title: title, status: item.status, paperfile: item.paperfile, isTermination: item.isTermination, updatetime: item.updatetime, emailaddre: item.emailaddre, authorList: item.authorList,autoid:item.autoid })
            loading.value = false
        })
    })
}

// 获取会议投稿论文列表(被删除的)
function getConferencePaperDelList() {
    conferencePaperDelList.value = []
    request.get(`/conference/paperlist?pagenum=1&pagesize=99999&cid=${route.query.cid}&sortRule=${sortRule.value}&keyword=${searchValue.value}&isDelete=1`).then((res) => {
        let datalist = res.data.list;
        datalist.forEach((item) => {
            let authornamelist = []
            item.authorList.forEach((author) => {
                authornamelist.push(author.firstname + " " + author.lastname)
            })
            let authornames = authornamelist.join(",")
            let title = item.title
            conferencePaperDelList.value.push({ id: item.id, pid: item.pid, authors: authornames, title: title, status: item.status, paperfile: item.paperfile, isTermination: item.isTermination, updatetime: item.updatetime, emailaddre: item.emailaddre, authorList: item.authorList,autoid:item.autoid })
        })
    })
}


// 搜索值改变，修改后端
const changeSearchValue = (payload) => {
    setTimeout(() => {
        getConferencePaperList()
    }, 500);  
}

// 查看论文详细信息
const look = (index, row) => {
    window.open(`#/common/detailpaper?pid=${row.pid}&role=3&acronym=${route.query.acronym}`, '_blank');
}

//下载PDF
const download = (index, payload) => {
    let acronym = route.query.acronym.split(" ").join("_")
    let autoid = payload.autoid
    saveAs(payload.paperfile, `${acronym}_paper_${autoid}.pdf`)
}


// 筛选表格
const filterTag = (value, row) => {
    multipleTableRef.value.clearSelection()
    // 筛选录用
    if (value == "ACCEPT") {
        return row.status == 4 && row.isTermination != 1
    }
    // 筛选拒稿
    else if (value == "REJECT") {
        return row.isTermination == 1
    }
    else {
        return row.status <= 3 && row.isTermination != 1
    }
}

// 发送预处理
const presend = () => {
    // 空值效验
    if (!emailform.value.subject) {
        ElMessage({
            message: `subject cannot be empty`,
            type: 'warning',
        })
        return
    }
    else if (!emailform.value.message) {
        ElMessage({
            message: `message cannot be empty`,
            type: 'warning',
        })
        return
    }
    else if (multipleSelection.value.length == 0) {
        ElMessage({
            message: `emaillist cannot be empty`,
            type: 'warning',
        })
        return
    }
    // 构建邮件列表
    emailList.value = []
    if (emailform.value.isAllCorresponding) {
        multipleSelection.value.forEach((item) => {
            item.authorList.forEach((author) => {
                emailList.value.push(author.email)
            })
        })
    }
    else {
        multipleSelection.value.forEach((item) => {
            item.authorList.forEach((author) => {
                if (author.isCorresponding == 1) {
                    emailList.value.push(author.email)
                }
            })
        })
    }
    // 空文件后端传值
    if (fileList.value.length == 0) {
        let data = {
            subject: emailform.value.subject,
            message: emailform.value.message,
            emailList: [...new Set(emailList.value)].join(","),
        }
        request.post("/authoremail", data, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
            if (res.code == 200) {
                ElMessage({
                    message: 'the email has been sent',
                    type: 'success',
                })
            }
        })
    }
    else {
        uploadRef.value.submit()
    }


}

// 附件形式发送邮件
const sendemail = (payload) => {
    let data = {
        subject: emailform.value.subject,
        message: emailform.value.message,
        emailList: [...new Set(emailList.value)].join(","),
        file: payload.file
    }
    request.post("/authoremail", data, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'the email has been sent',
                type: 'success',
            })
        }
    })
}

// 获取排序列和排序规则，交由后端负责排序
const sortTable = (payload) => {
    if (payload.column.order == "ascending") {
        sortRule.value = payload.column.label.toLowerCase() + " " + payload.column.order.substring(0, 3)
        getConferencePaperList()
    }
    else if (payload.column.order == "descending") {
        sortRule.value = payload.column.label.toLowerCase() + " " + payload.column.order.substring(0, 4)
        getConferencePaperList()
    }
    else {
        sortRule.value = "autoid desc"
        getConferencePaperList()
    }

}

// 删除论文
const deletepaper = (payload) => {
    // 构建邮件列表
    deleteList.value = []
    multipleSelection.value.forEach((item) => {
        deleteList.value.push(item.pid)
    })
    let data = {
        pidList: [...new Set(deleteList.value)],
    }
    request.post("/paper/delete", data).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'delete successful',
                type: 'success',
            })
            conferencePaperList.value = conferencePaperList.value.filter((item) => {
                if (deleteList.value.indexOf(item.pid) == -1) {
                    return true
                }
                else {
                    return false
                }
            })
        }
        else {
            ElMessage({
                message: res.msg,
                type: 'warning',
            })
        }
    })
}

// 已经被删除的论文集
const deleted = () => {
    dialogTableVisible.value = true
    getConferencePaperDelList()
}

// 恢复论文
const recover = () => {
    // 构建邮件列表
    deleteList.value = []
    multipleSelection.value.forEach((item) => {
        deleteList.value.push(item.pid)
    })
    let data = {
        pidList: [...new Set(deleteList.value)],
    }
    request.post("/paper/recover", data).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'recovery was successful',
                type: 'success',
            })
            getConferencePaperList()
            dialogTableVisible.value = false
        }
        else {
            ElMessage({
                message: res.msg,
                type: 'warning',
            })
        }
    })
}


onMounted(() => {
    // 获取会议投稿论文列表
    getConferencePaperList()
})

</script>

<style lang="scss">
.authoremail-box {
    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }

}
</style>